
    <div [hidden]="!barcodeValue">
      {{ barcodeValue }}
    </div>
